(() => {
  const settingsNode = document.querySelector('[data-dg-gift-settings]');
  if (!settingsNode) return;
  const settings = JSON.parse(settingsNode.textContent);
  const labels = settings.labels;
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function normalize(item) {
    if (!item || !/^\d+$/.test(String(item.id)) || typeof item.title !== 'string') return null;
    try {
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !/\/products\//.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      let image = typeof item.image === 'object' ? item.image?.src : item.image;
      if (image) {
        const imageUrl = new URL(image, location.origin);
        image = imageUrl.protocol === 'https:' && (imageUrl.hostname === location.hostname || imageUrl.hostname.endsWith('.shopify.com')) ? imageUrl.href : '';
      }
      return { id: String(item.id), title: item.title.slice(0, 300), url: url.href, image: image || '' };
    } catch { return null; }
  }
  let quickDialog;
  let quickOpener;
  let quickPreviousOverflow;
  const feedbackTimers = new WeakMap();
  const moneyFor = product => value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: product.currency || 'USD' }).format(value / 100);
  function showAdded(notice) {
    notice.replaceChildren();
    const status = document.querySelector('[data-dg-gift-status]');
    if (status) {
      status.textContent = '';
      requestAnimationFrame(() => { status.textContent = labels.added; });
    }
  }
  function markAdded(button) {
    clearTimeout(feedbackTimers.get(button));
    button.dataset.dgAdded = 'true';
    button.setAttribute('aria-disabled', 'true');
    const check = element('span', 'dg-gift-added-check', '✓');
    check.setAttribute('aria-hidden', 'true');
    button.replaceChildren(check, document.createTextNode(labels.added));
    feedbackTimers.set(button, setTimeout(() => {
      delete button.dataset.dgAdded;
      button.removeAttribute('aria-disabled');
      button.textContent = labels.add;
      feedbackTimers.delete(button);
    }, 2400));
  }
  async function addVariant(variant, button, notice, opener = button, onAdded) {
    if (button.disabled || button.dataset.dgAdded || opener.dataset.dgAdded) return false;
    button.disabled = true;
    opener.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = labels.adding;
    notice.replaceChildren();
    let added = false;
    try {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const payload = new FormData();
      payload.set('id', String(variant.id));
      payload.set('quantity', '1');
      if (cart?.getSectionsToRender) {
        payload.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        payload.set('sections_url', location.pathname);
        cart.setActiveElement(opener);
      }
      const response = await fetch(`${settings.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: payload });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || labels.add_error);
      added = true;
      showAdded(notice);
      onAdded?.();
      if (cart?.renderContents) cart.renderContents(result);
      else {
        const cartResponse = await fetch(`${settings.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const current = await cartResponse.json();
          const bag = document.querySelector('#cart-icon-bubble');
          if (bag) {
            let count = bag.querySelector('.cart-count-bubble');
            if (!count) { count = element('span', 'cart-count-bubble'); bag.append(count); }
            count.textContent = String(current.item_count);
          }
        }
      }
    } catch (error) {
      if (!added) notice.textContent = error.message || labels.add_error;
    } finally {
      button.disabled = false;
      opener.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = labels.add;
      if (added) markAdded(opener);
    }
    return added;
  }
  function getQuickDialog() {
    if (quickDialog) return quickDialog;
    quickDialog = element('dialog', 'dg-quick-dialog');
    quickDialog.setAttribute('aria-labelledby', 'DuduQuickTitle');
    quickDialog.addEventListener('close', () => {
      document.body.style.overflow = quickPreviousOverflow || '';
      if (quickOpener?.isConnected && !quickOpener.disabled) quickOpener.focus({ preventScroll: true });
    });
    quickDialog.addEventListener('click', event => {
      if (event.target !== quickDialog) return;
      const rect = quickDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) quickDialog.close();
    });
    document.body.append(quickDialog);
    return quickDialog;
  }
  function openQuickAdd(product, item, variants, opener, cardNotice) {
    if (opener.disabled || opener.dataset.dgAdded) return;
    const dialog = getQuickDialog();
    if (dialog.open) return;
    const money = moneyFor(product);
    const personalize = product.personalized === true;
    const quantityRules = variants.some(variant => (variant.min || 1) > 1 || (variant.increment || 1) > 1);
    const needsProductPage = personalize || quantityRules;
    const header = element('div', 'dg-quick-heading');
    const heading = element('p', '', labels.quick_title);
    const close = element('button', 'dg-quick-close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', labels.close);
    close.addEventListener('click', () => dialog.close());
    header.append(heading, close);
    const content = element('div', 'dg-quick-content');
    const summary = element('div', 'dg-quick-summary');
    const imageLink = element('a', 'dg-quick-photo');
    imageLink.href = item.url;
    imageLink.setAttribute('aria-label', item.title);
    const image = element('img');
    image.alt = item.title;
    image.width = image.height = 300;
    if (item.image) { image.src = item.image; imageLink.append(image); }
    else imageLink.hidden = true;
    const copy = element('div', 'dg-quick-copy');
    const title = element('h2', '', item.title);
    title.id = 'DuduQuickTitle';
    const prices = variants.map(variant => variant.price);
    const minimum = Math.min(...prices);
    const price = element('p', 'dg-quick-price', `${Math.max(...prices) > minimum ? `${labels.from} ` : ''}${money(minimum)}`);
    price.setAttribute('aria-live', 'polite');
    const details = element('a', 'dg-quick-details', labels.view_details);
    details.href = item.url;
    copy.append(title, price, details);
    summary.append(imageLink, copy);
    const form = element('form', 'dg-quick-form');
    const hint = element('p', 'dg-quick-hint', personalize ? labels.personalization_hint : quantityRules ? labels.quantity_hint : labels.options_hint);
    hint.id = 'DuduQuickHint';
    const selectLabel = element('label', 'dg-quick-label', labels.options);
    selectLabel.htmlFor = 'DuduQuickVariant';
    const select = element('select', 'dg-gift-variant');
    select.id = 'DuduQuickVariant';
    select.name = 'id';
    select.required = true;
    select.setAttribute('aria-describedby', hint.id);
    const placeholder = element('option', '', labels.select_variant);
    placeholder.value = '';
    placeholder.disabled = placeholder.selected = true;
    select.append(placeholder);
    variants.forEach(variant => {
      const option = element('option', '', `${variant.title} — ${money(variant.price)}`);
      option.value = String(variant.id);
      select.append(option);
    });
    const notice = element('p', 'dg-gift-quick-notice');
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    const action = element(needsProductPage ? 'a' : 'button', 'dg-gift-quick-button', personalize ? labels.personalize : quantityRules ? labels.view_details : labels.add);
    if (needsProductPage) action.href = item.url;
    else { action.type = 'submit'; action.disabled = true; }
    let selected;
    const choose = () => {
      selected = variants.find(variant => String(variant.id) === select.value);
      if (!selected) return;
      price.textContent = money(selected.price);
      notice.replaceChildren();
      if (selected.image) {
        image.src = selected.image;
        if (!image.isConnected) imageLink.append(image);
        imageLink.hidden = false;
      }
      const url = new URL(item.url);
      url.searchParams.set('variant', String(selected.id));
      details.href = imageLink.href = url.href;
      if (needsProductPage) action.href = url.href;
      else action.disabled = false;
    };
    select.addEventListener('change', choose);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (needsProductPage) { action.click(); return; }
      if (!selected || action.disabled) return;
      await addVariant(selected, action, notice, opener, () => {
        showAdded(cardNotice);
        dialog.close();
      });
    });
    if (variants.length > 1) form.append(selectLabel, select);
    else {
      select.value = String(variants[0].id);
      choose();
      if (product.has_options === true) form.append(element('p', 'dg-quick-selected', variants[0].title));
      if (!needsProductPage) hint.hidden = true;
    }
    form.append(hint, action, notice);
    content.append(summary, form);
    dialog.replaceChildren(header, content);
    quickOpener = opener;
    quickPreviousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    (variants.length > 1 ? select : action).focus({ preventScroll: true });
  }
  if (!customElements.get('dg-gift-actions')) customElements.define('dg-gift-actions', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-dg-card-product]');
      if (!data) return;
      let product;
      try { product = JSON.parse(data.textContent); } catch { return; }
      const item = normalize(product);
      if (!item) return;
      this.ready = true;
      const actions = element('div', 'dg-gift-quick-actions');
      const notice = element('p', 'dg-gift-quick-notice');
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      const variants = (product.variants || []).filter(variant => variant.available);
      if (!variants.length) {
        const link = element('a', 'dg-gift-quick-button', labels.view_details);
        link.href = item.url;
        actions.append(link);
      } else {
        const needsOptions = product.has_options === true || product.personalized === true || (product.variants || []).length > 1 || variants.some(variant => (variant.min || 1) > 1 || (variant.increment || 1) > 1);
        const button = element('button', 'dg-gift-quick-button', labels.add);
        button.type = 'button';
        if (needsOptions) {
          button.setAttribute('aria-haspopup', 'dialog');
          button.addEventListener('click', () => openQuickAdd(product, item, variants, button, notice));
        } else button.addEventListener('click', () => addVariant(variants[0], button, notice));
        actions.append(button);
      }
      const fallback = this.querySelector('[data-dg-card-fallback]');
      if (fallback) fallback.hidden = true;
      this.append(actions, notice);
    }
  });
  function observedDate(year, month, day) {
    const date = new Date(Date.UTC(year, month, day, 12));
    if (date.getUTCDay() === 6) date.setUTCDate(date.getUTCDate() - 1);
    if (date.getUTCDay() === 0) date.setUTCDate(date.getUTCDate() + 1);
    return date.toISOString().slice(0, 10);
  }
  function weekdayOfMonth(year, month, weekday, occurrence) {
    const date = new Date(Date.UTC(year, month, 1, 12));
    date.setUTCDate(1 + (weekday - date.getUTCDay() + 7) % 7 + 7 * (occurrence - 1));
    return date.toISOString().slice(0, 10);
  }
  function holidays(year) {
    const memorial = new Date(Date.UTC(year, 5, 0, 12));
    while (memorial.getUTCDay() !== 1) memorial.setUTCDate(memorial.getUTCDate() - 1);
    return new Set([
      observedDate(year, 0, 1), weekdayOfMonth(year, 0, 1, 3), weekdayOfMonth(year, 1, 1, 3),
      memorial.toISOString().slice(0, 10), observedDate(year, 5, 19), observedDate(year, 6, 4),
      weekdayOfMonth(year, 8, 1, 1), weekdayOfMonth(year, 9, 1, 2), observedDate(year, 10, 11),
      weekdayOfMonth(year, 10, 4, 4), observedDate(year, 11, 25)
    ]);
  }
  function addBusinessDays(start, count) {
    const date = new Date(start);
    const excluded = new Set([...holidays(date.getUTCFullYear() - 1), ...holidays(date.getUTCFullYear()), ...holidays(date.getUTCFullYear() + 1)]);
    let remaining = count;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !excluded.has(date.toISOString().slice(0, 10))) remaining--;
    }
    return date;
  }
  function updateArrivalWindows() {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const part = type => Number(parts.find(value => value.type === type).value);
    const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
    document.querySelectorAll('[data-dg-delivery-min][data-dg-delivery-max]').forEach(node => {
      const minimum = Number(node.dataset.dgDeliveryMin);
      const maximum = Number(node.dataset.dgDeliveryMax);
      if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum < 1 || maximum < minimum || maximum > 90) return;
      const start = addBusinessDays(today, minimum);
      const end = addBusinessDays(today, maximum);
      const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric', ...(start.getUTCFullYear() !== end.getUTCFullYear() ? { year: 'numeric' } : {}), timeZone: 'UTC' });
      let line = node.previousElementSibling;
      if (!line?.matches('[data-dg-arrival-date]')) {
        line = element('p', 'dg-arrival-date');
        line.dataset.dgArrivalDate = '';
        node.before(line);
      }
      line.replaceChildren(document.createTextNode(`${labels.arrival}: `));
      const first = element('time', '', formatter.format(start));
      first.dateTime = start.toISOString().slice(0, 10);
      const last = element('time', '', formatter.format(end));
      last.dateTime = end.toISOString().slice(0, 10);
      line.append(first, document.createTextNode(' – '), last);
    });
  }
  window.DuduGiftTools = { addBusinessDays, updateArrivalWindows };
  updateArrivalWindows();
  document.addEventListener('shopify:section:load', updateArrivalWindows);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateArrivalWindows(); });
})();

